import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity NonProfitOrganisation
 */
@Entity()
export class NonProfitOrganisation extends Partner {
  static override _class = 'NonProfitOrganisation';

  override get type() {
    return KooperationsPartner.NON_PROFIT_ORANISATION;
  }
}
